import React, { useState, useEffect, useCallback } from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import IconBack from '@material-ui/icons/ArrowBack'
import { IconButton } from '@material-ui/core'
import { connect } from 'react-redux'
import { Flex } from 'components/common/styles'
import { Header, SearchField, Title } from 'styles/app/apps/main-style'
import { FormatMessage } from 'types/common'
import { usePrevious } from 'react-use'
import Psfs from 'lib/psfs/Psfs'
import { debounce } from 'lodash'
import messages from './translate'

type PdfReportsHeaderProps = WrappedComponentProps & {
  intl: { formatMessage: FormatMessage }
  fetchPdfReportData: (psfs: Psfs) => void
  tablePsfs: Psfs
  appName: string
  goBack: () => void
  featureFlags: Record<string, boolean>
}

function PdfReportsHeader({
  intl: { formatMessage },
  fetchPdfReportData,
  tablePsfs,
  appName,
  goBack,
  featureFlags,
}: PdfReportsHeaderProps) {
  const { path, searchObj } = tablePsfs
  const search = searchObj as { value: string } | null
  const [searchValue, setSearchValue] = useState(search?.value ?? '')
  const prevSearchValue = usePrevious(searchValue)

  const fetchPdfReportDataDebounced = useCallback(
    debounce(fetchPdfReportData, 1000),
    [],
  )

  useEffect(() => {
    if (searchValue !== prevSearchValue && prevSearchValue !== undefined) {
      const psfs = new Psfs(path)
      psfs.addSearch(searchValue)
      fetchPdfReportDataDebounced(psfs)
    }
  }, [searchValue])

  return (
    <Header
      className="jobs-triggers-header"
      justify="space-between"
      align="center"
      isNewHeader={featureFlags.APP_HEADER_V2}>
      <Flex>
        <Title>
          <IconButton size="medium" className="btn-back" onClick={goBack}>
            <IconBack fontSize="small" />
          </IconButton>
          {appName}
        </Title>
        <Flex align="center">
          <SearchField
            placeholder={formatMessage(messages.search)}
            onChange={({ target: { value } }) => setSearchValue(value)}
            value={searchValue}
            disableUnderline
          />
        </Flex>
      </Flex>
    </Header>
  )
}

export default connect(
  (state: {
    getIn: (path: Array<string>) => Record<string, boolean> | Psfs
  }) => ({
    featureFlags: state.getIn(['profile', 'profile', 'featureFlags']) as Record<
      string,
      boolean
    >,
    tablePsfs: state.getIn(['pdfReports', 'tablePsfs']) as Psfs,
  }),
  {},
)(injectIntl(PdfReportsHeader))
